import React from "react";
import './index.sass';
import {
    Table,
    Image
} from 'antd';
import 'moment/locale/zh-cn';

export default class DeliveryDetail extends React.Component {
    constructor(props) {
        super(props)

        const columns = [
            {
                title: '商品名称',
                dataIndex: 'goods_name',
                key: 'goods_name',
            },
            {
                title: '商品图片',
                // dataIndex: 'entity_img',
                render: (ctx) => {
                    //console.log(ctx, )
                    return (
                        <Image style={{ maxHeight: 50, maxWidth: 50 }} src={ctx['entity_img']} />
                    )
                }
            },
            {
                title: '单价',
                dataIndex: 'entity_price',
                key: 'entity_price',
            },
            {
                title: '数量',
                dataIndex: 'buy_quantity',
                key: 'buy_quantity',
            },
            {
                title: '实收款',
                dataIndex: 'item_payment_amount',
                key: 'item_payment_amount',
            }
        ]

        this.state = {
            order_id: 1 || props.location.state.id,
            detail: { group: {}, order_mailing: {} } || props.location.state.detail,
            columns: columns,
            dataSource: []
        }
    }


    componentDidMount(props) {
        //console.log(props)
        //this.orderDetail()//商家查看订单详情
    }

    // orderDetail = async () => {//商家查看订单详情
    // 	const { order_id } = this.state
    // 	let param = {
    // 		order_id: order_id
    // 	}

    // 	let res = await OrderDetailRequest.send(param)
    // 	if (res.status) {
    // 		this.setState({
    // 			detail: res['data']
    // 		})
    // 	}

    // }

    cancel = () => {//取消visable
        this.setState({
            remarkVisible: false
        })
    }

    // addRemark = async (param) => {
    // 	const hide = message.loading('添加备注中')
    // 	let res = await AddRemarkRequest.send(param)
    // 	if (res.status) {
    // 		message.success('添加成功！')
    // 	} else {
    // 		message.error(res.message)
    // 	}
    // 	hide()
    // 	this.cancel()
    // 	//this.orderDetail();//重新拉取
    // }

    conAddremark = () => {
    }


    render() {
        const { detail } = this.state;


        const dataSource = [
        ];

        const columns_goods = [
            {
                title: '商品编码',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '商品名称',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '商品条码',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '单价',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '数量',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '总金额',
                dataIndex: 'address',
                key: 'address',
            },
        ];

        const columns_orders = [
            {
                title: '团购/合约/商城订单名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '订单编号',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '所属商户（团长）',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '用户名',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '用户手机号',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '商品信息',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '订单状态',
                dataIndex: 'address',
                key: 'address',
            }
        ];


        const columns_delivery = [
            {
                title: '配送点名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '配送点地址',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '商品名称',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '商品件数',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '商品总件数',
                dataIndex: 'address',
                key: 'address',
            }
        ];

        return (
            <div className='deliveryDetail'>
                {detail ? (
                    <div className='detailBox'>
                        <div className='line'>
                            <div className='title'>配送单详情</div>
                            <ul className='lineinfo'>
                                <li><p>配送单号：</p>31321343132</li>
                                <li><p>状态：</p>待配送</li>
                                <li><p>生成时间：</p>2022年4月15日 12:30</li>
                            </ul>
                        </div>

                        <div className='line'>
                            <div className='title'>生成条件</div>
                            <ul className='lineinfo'>
                                <li><p>合约订单：</p>1.端午节前大促销商品，全场满100送精美礼品；2.劳动节前大促销商品，全场满100送清洁套装；3.大促销商品，全场满100送零食一包！</li>
                                <li><p>团购订单：</p>1.端午节前大促销商品，全场满100送精美礼品；2.劳动节前大促销商品，全场满100送清洁套装；</li>
                                <li><p>商城订单：</p>2022-04-12 14:32 ~ 2022-04-15 14:32 时间段内的订单</li>
                                <li><p>备注：</p>这个是昨天的配送单，别忘了！</li>
                            </ul>
                        </div>

                        <div className='line'>
                            <div className='title'>商品汇总列表 </div>
                            <Table dataSource={dataSource} columns={columns_goods} />
                        </div>

                        <div className='line'>
                            <div className='title'>订单列表 </div>
                            <Table dataSource={dataSource} columns={columns_orders} />
                        </div>

                        <div className='line'>
                            <div className='title'>配送点列表 </div>
                            <Table dataSource={dataSource} columns={columns_delivery} />
                        </div>



                    </div>
                ) : (
                    <p>加载数据中</p>
                )}
            </div>
        )
    }
}